import { useSelector } from 'react-redux';
// @ts-expect-error no-type
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollaborationSidebarWithWrapper({
  children
}) {
  const hasPatagonia = useSelector(getIsUngatedForPatagonia);
  return /*#__PURE__*/_jsxs("div", {
    className: 'layout-and-collaboration-sidebar' + (!hasPatagonia ? " non-patagonia-collaboration-sidebar" : ""),
    children: [children, /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        CollaborationSidebarContainer
      }) => /*#__PURE__*/_jsx(CollaborationSidebarContainer, {})
    })]
  });
}